import { dateFromISOString } from "@prismicio/editor-support/Date"
import {
  Box,
  DateInput,
  Field,
  FieldControl,
  FieldIcon,
  FieldLabel,
} from "@prismicio/editor-ui"
import type { DateContent } from "@prismicio/types-internal/lib/content"
import type { Date as DateT } from "@prismicio/types-internal/lib/customtypes"

import { getFieldLabel } from "./utils"

interface Props {
  id: string
  readOnly: boolean
  field: DateT
  content?: DateContent
  onContentChange: (content?: DateContent) => void
}

export function DateField(props: Props) {
  const { id, readOnly, field, content, onContentChange } = props

  const value = content?.value ? dateFromISOString(content.value) : undefined

  return (
    <Field>
      <FieldIcon name="dateRange" />
      <FieldLabel id={id}>{getFieldLabel(field)}</FieldLabel>
      <FieldControl>
        <Box
          padding={{ left: 4, right: 12 }}
          width="100%"
          flexDirection="column"
          justifyContent="center"
        >
          <DateInput
            mode="date"
            aria-labelledby={id}
            disabled={readOnly}
            value={value}
            onValueChange={(newValue) =>
              onContentChange(updateContent(newValue))
            }
          />
        </Box>
      </FieldControl>
    </Field>
  )
}

function updateContent(value?: Date): DateContent | undefined {
  if (!value) return undefined

  return {
    __TYPE__: "FieldContent",
    type: "Date",
    value: toPrismicDateValue(value),
  }
}

function toPrismicDateValue(date: Date): string {
  const YYYY = `${date.getFullYear()}`.padStart(4, "0")
  const MM = `${date.getMonth() + 1}`.padStart(2, "0")
  const DD = `${date.getDate()}`.padStart(2, "0")

  return `${YYYY}-${MM}-${DD}`
}
